var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseWhiteFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3334 9.00008C17.3334 13.6025 13.6025 17.3334 9.00008 17.3334C4.39771 17.3334 0.666748 13.6025 0.666748 9.00008C0.666748 4.39771 4.39771 0.666748 9.00008 0.666748C13.6025 0.666748 17.3334 4.39771 17.3334 9.00008ZM11.8001 7.08342L9.8834 9.00008L11.8001 10.9167C12.0417 11.1584 12.0417 11.5584 11.8001 11.8001C11.6751 11.9251 11.5167 11.9834 11.3584 11.9834C11.2001 11.9834 11.0417 11.9251 10.9167 11.8001L9.00007 9.88342L7.0834 11.8001C6.9584 11.9251 6.80007 11.9834 6.64174 11.9834C6.4834 11.9834 6.32507 11.9251 6.20007 11.8001C5.9584 11.5584 5.9584 11.1584 6.20007 10.9167L8.11674 9.00008L6.20007 7.08342C5.9584 6.84175 5.9584 6.44175 6.20007 6.20008C6.44174 5.95842 6.84174 5.95842 7.0834 6.20008L9.00007 8.11675L10.9167 6.20008C11.1584 5.95842 11.5584 5.95842 11.8001 6.20008C12.0417 6.44175 12.0417 6.84175 11.8001 7.08342Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteFilled);
export default __webpack_public_path__ + "static/media/close-white-filled.9bbce6df8a975b618330e447770a670c.svg";
export { ForwardRef as ReactComponent };